var map = {
	"./1893/01.jpg": "1f59",
	"./1893/01_full.jpg": "e98b",
	"./1893/02.jpg": "c01e",
	"./1893/02_full.jpg": "97f8",
	"./1893/03.jpg": "bd49",
	"./1893/03_full.jpg": "bec1",
	"./1893/04.jpg": "ac74",
	"./1893/04_full.jpg": "8e63",
	"./1893/05.jpg": "f918",
	"./1893/05_full.jpg": "77960",
	"./1893/06.jpg": "2424",
	"./1893/06_full.jpg": "f281",
	"./1893/07.jpg": "968b",
	"./1893/07_full.jpg": "d035",
	"./1893/08.jpg": "a320",
	"./1893/08_full.jpg": "144a",
	"./1893/intro.jpg": "88bc",
	"./1925/01.jpg": "aab2",
	"./1925/01_full.jpg": "7a5e",
	"./1925/02.jpg": "141c",
	"./1925/02_full.jpg": "b367",
	"./1925/03.jpg": "802f",
	"./1925/03_full.jpg": "ad35",
	"./1925/04.jpg": "09c7",
	"./1925/04_full.jpg": "5aa2",
	"./1925/05.jpg": "166e",
	"./1925/05_full.jpg": "5403",
	"./1925/06.jpg": "95a4",
	"./1925/06_full.jpg": "70b1",
	"./1925/intro.jpg": "e6eb",
	"./1949/01.jpg": "e7a3",
	"./1949/01_full.jpg": "bec2",
	"./1949/02.jpg": "c8b6",
	"./1949/02_full.jpg": "29a5",
	"./1949/03.jpg": "048f",
	"./1949/03_full.jpg": "cda1",
	"./1949/04.jpg": "f084",
	"./1949/04_full.jpg": "3376",
	"./1949/intro.jpg": "5fa2",
	"./1951/01.jpg": "7a32",
	"./1951/01_full.jpg": "10cf",
	"./1951/02.jpg": "36ed",
	"./1951/02_full.jpg": "0ffd",
	"./1951/03.jpg": "fb9f",
	"./1951/03_full.jpg": "0a5b",
	"./1951/intro.jpg": "6cc9",
	"./1956/01.jpg": "81a4",
	"./1956/01_full.jpg": "299b",
	"./1956/02.jpg": "b485",
	"./1956/02_full.jpg": "994b",
	"./1956/03.jpg": "8d06",
	"./1956/03_full.jpg": "a271",
	"./1956/intro.jpg": "0071",
	"./1960/01.jpg": "fc8b",
	"./1960/01_full.jpg": "a2ae",
	"./1960/02.jpg": "f100",
	"./1960/02_full.jpg": "4d24",
	"./1960/03.jpg": "b55d",
	"./1960/03_full.jpg": "ed97",
	"./1960/04.jpg": "4f14",
	"./1960/04_full.jpg": "8423",
	"./1960/intro.jpg": "2868",
	"./1982/01.jpg": "b9de",
	"./1982/01_full.jpg": "4ad2",
	"./1982/02.jpg": "bb61",
	"./1982/02_full.jpg": "8cfc",
	"./1982/03.jpg": "409d",
	"./1982/03_full.jpg": "beea",
	"./1982/intro.jpg": "a34a",
	"./1993/01.jpg": "3d5a",
	"./1993/01_full.jpg": "fbff",
	"./1993/02.jpg": "8a83",
	"./1993/02_full.jpg": "2a65",
	"./1993/03.jpg": "b941",
	"./1993/03_full.jpg": "8022",
	"./1993/04.jpg": "6471",
	"./1993/04_full.jpg": "30bd",
	"./1993/05.jpg": "fed3",
	"./1993/05_full.jpg": "cf55",
	"./1993/06.jpg": "b0b2",
	"./1993/06_full.jpg": "fe1f",
	"./1993/07.jpg": "bf39",
	"./1993/07_full.jpg": "2135",
	"./1993/08.jpg": "3d68",
	"./1993/08_full.jpg": "87e0",
	"./1993/09.jpg": "1d56",
	"./1993/09_full.jpg": "696e",
	"./1993/intro.jpg": "6030",
	"./2016/01.jpg": "9f7f",
	"./2016/01_full.jpg": "0841",
	"./2016/02.jpg": "caa8",
	"./2016/02_full.jpg": "7b3e",
	"./2016/03.jpg": "10ed",
	"./2016/03_full.jpg": "356c",
	"./2016/04.jpg": "a765",
	"./2016/04_full.jpg": "1a86",
	"./2016/05.jpg": "449d",
	"./2016/05_full.jpg": "830f",
	"./2016/intro.jpg": "f30f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9308";